import React from "react";
import { Box, FormControlLabel, MenuItem, Switch, TextField } from "@mui/material";
import { TIPOS_DOCUMENTO_ESTRANGEIRO, limparNumeroEstrangeiro, limparPaisEstrangeiro } from "../utils/documentoEstrangeiro";

/**
 * Flag "<Cadastro> estrangeiro" + campos do documento estrangeiro (tipo, número e país).
 * `valor` traz estrangeiro/documentoEstrangeiroTipo/Numero/Pais; `onChange(campo, valor)`
 * recebe cada alteração. `campoSx(campo)` permite aplicar o estilo de campo da tela.
 */
export default function DocumentoEstrangeiroCampos({
  valor = {},
  onChange,
  somenteLeitura = false,
  erros = {},
  campoSx,
  mostrarFlag = true,
  rotuloFlag = "Estrangeiro",
  obrigatorio = true,
}) {
  const sx = (campo) => (typeof campoSx === "function" ? campoSx(campo) : campoSx) || {};
  const alterar = (campo, v) => {
    if (!somenteLeitura) onChange?.(campo, v);
  };

  if (!mostrarFlag && !valor.estrangeiro) return null;
  // Com CPF/CNPJ informado o documento estrangeiro é opcional (sem asterisco).
  const ast = obrigatorio ? "*" : "";
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, width: "100%" }}>
      {mostrarFlag && <FlagEstrangeiro valor={valor} onChange={onChange} somenteLeitura={somenteLeitura} rotulo={rotuloFlag} />}

      {valor.estrangeiro && (
        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
          <TextField
            select
            size="small"
            label={`Tipo de documento${ast}`}
            value={valor.documentoEstrangeiroTipo || ""}
            onChange={(e) => alterar("documentoEstrangeiroTipo", e.target.value)}
            error={!!erros.documentoEstrangeiroTipo}
            helperText={erros.documentoEstrangeiroTipo || " "}
            slotProps={{ input: { readOnly: somenteLeitura } }}
            sx={{ flex: "1 1 220px", ...sx("documentoEstrangeiroTipo") }}
          >
            {TIPOS_DOCUMENTO_ESTRANGEIRO.map((t) => (
              <MenuItem key={t.valor} value={t.valor}>
                {t.label}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            size="small"
            label={`Nº do documento${ast}`}
            value={valor.documentoEstrangeiroNumero || ""}
            onChange={(e) => alterar("documentoEstrangeiroNumero", limparNumeroEstrangeiro(e.target.value))}
            error={!!erros.documentoEstrangeiroNumero}
            helperText={erros.documentoEstrangeiroNumero || " "}
            slotProps={{ input: { readOnly: somenteLeitura }, htmlInput: { maxLength: 50 } }}
            sx={{ flex: "1 1 220px", ...sx("documentoEstrangeiroNumero") }}
          />
          <TextField
            size="small"
            label={`País emissor${ast}`}
            value={valor.documentoEstrangeiroPais || ""}
            onChange={(e) => alterar("documentoEstrangeiroPais", limparPaisEstrangeiro(e.target.value))}
            error={!!erros.documentoEstrangeiroPais}
            helperText={erros.documentoEstrangeiroPais || " "}
            slotProps={{ input: { readOnly: somenteLeitura }, htmlInput: { maxLength: 100 } }}
            sx={{ flex: "1 1 180px", ...sx("documentoEstrangeiroPais") }}
          />
        </Box>
      )}
    </Box>
  );
}

/**
 * Interruptor "<Cadastro> estrangeiro" (ex.: Locatário estrangeiro, Fiador estrangeiro),
 * para ficar ao lado do campo de CPF/CNPJ.
 */
export function FlagEstrangeiro({ valor = {}, onChange, somenteLeitura = false, rotulo = "Estrangeiro", sx }) {
  return (
    <FormControlLabel
      control={
        <Switch
          size="small"
          checked={Boolean(valor.estrangeiro)}
          onChange={(e) => !somenteLeitura && onChange?.("estrangeiro", e.target.checked)}
          disabled={somenteLeitura}
          sx={{
            "& .MuiSwitch-switchBase.Mui-checked": { color: "#1998a8" },
            "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: "#1998a8", opacity: 0.6 },
          }}
        />
      }
      label={rotulo}
      sx={{
        color: "var(--ig-t-cccccc)",
        m: 0,
        whiteSpace: "nowrap",
        "& .MuiFormControlLabel-label": { fontSize: "0.85rem", fontWeight: 600 },
        "& .MuiFormControlLabel-label.Mui-disabled": { color: "var(--ig-t-aaaaaa)" },
        ...sx,
      }}
    />
  );
}
